export const GET_MARKETS_INIT = 'GET_MARKETS_INIT'
export const GET_MARKETS_SUCCESS = 'GET_MARKETS_SUCCESS'
export const GET_MARKETS_ERROR = 'GET_MARKETS_ERROR'

export const GET_CATEGORIES_INIT = 'GET_CATEGORIES_INIT'
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS'
export const GET_CATEGORIES_ERROR = 'GET_CATEGORIES_ERROR'

export const GET_FAMILIES_INIT = 'GET_FAMILIES_INIT'
export const GET_FAMILIES_SUCCESS = 'GET_FAMILIES_SUCCESS'
export const GET_FAMILIES_ERROR = 'GET_FAMILIES_ERROR'

export const GET_ROOTS_INIT = 'GET_ROOTS_INIT'
export const GET_ROOTS_SUCCESS = 'GET_ROOTS_SUCCESS'
export const GET_ROOTS_ERROR = 'GET_ROOTS_ERROR'

export const GET_SECTORS_INIT = 'GET_SECTORS_INIT'
export const GET_SECTORS_SUCCESS = 'GET_SECTORS_SUCCESS'
export const GET_SECTORS_ERROR = 'GET_SECTORS_ERROR'

export const GET_SUBMARKETS_INIT = 'GET_SUBMARKETS_INIT'
export const GET_SUBMARKETS_SUCCESS = 'GET_SUBMARKETS_SUCCESS'
export const GET_SUBMARKETS_ERROR = 'GET_SUBMARKETS_ERROR'

export const GET_SEGMENTS_INIT = 'GET_SEGMENTS_INIT'
export const GET_SEGMENTS_SUCCESS = 'GET_SEGMENTS_SUCCESS'
export const GET_SEGMENTS_ERROR = 'GET_SEGMENTS_ERROR'

export const GET_NOMENCLATURES_INIT = 'GET_NOMENCLATURES_INIT'
export const GET_NOMENCLATURES_SUCCESS = 'GET_NOMENCLATURES_SUCCESS'
export const GET_NOMENCLATURES_ERROR = 'GET_NOMENCLATURES_ERROR'
